import React from "react";
import LoginEmailForm from "../components/login/LoginEmail";

const LoginEmail = () => {
  return <LoginEmailForm />;
};

export default LoginEmail;
